<script>
    import Title from "../components/Title.svelte";
    import Button from "../components/Button.svelte";
    import SmallTitle from "../components/SmallTitle.svelte";
    import Background from "../components/Background.svelte";
    import {links} from "../links";
</script>

<section id="download-action">
    <Background>
        <img class="bg-1" src="images/index/app-bg-1.svg">
        <img class="bg-2" src="images/index/app-bg-2.svg">
    </Background>

    <Title title="『红宝书词汇』APP" hint="书籍配套 视听促记 高效智能 随时复习" />
    <div class="action-container">
        <div class="buttons">
            <Button icon="images/index/苹果@1x.svg" text="iPhone 下载" link={links.苹果下载}/>
            <Button icon="images/index/安卓@1x.svg" text="Android 下载" link={links.安卓下载}/>
        </div>
    </div>
    <div class="content">
        <div>
            <SmallTitle title="「打卡签到」" hint="好好学习 天天向上" />
            <div class="app-screen">
                <img src="images/index/打卡签到图例.png"/>
            </div>
        </div>
        <div>
            <SmallTitle title="「定制计划」" hint="词书配套 灵活方便" />
            <div class="app-screen">
                <img src="images/index/定制计划图例.png"/>
            </div>
        </div>

        <div>
            <SmallTitle title="「学习资源」" hint="考研资料 应有尽有" />
            <div class="app-screen">
                <img src="images/index/学习资源图例.png"/>
            </div>
        </div>
    </div>
</section>

<style>
    #download-action {
        margin-top: 72px;
    }

    .bg-1 {
        position: absolute;
        top: 58px;
        left: 0;
        width: 96px;
    }
    .bg-2 {
        position: absolute;
        top: 182px;
        right: 0;
        width: 145px;
    }

    .action-container {
        margin: 32px 22px 0;
    }

    .buttons {
        width: 100%;
        display: grid;
        gap: 10px;
        align-items: center;
        grid-template-columns: repeat(auto-fit, 160px);
    }

    .content {
        margin-top: 36px;
        display: grid;
        align-items: center;
        justify-content: center;
        grid-template-columns: repeat(auto-fit, 110px);
    }

    .app-screen img {
        width: 110px;
    }
</style>
